import { makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { notifications } from '@shared/utils/notifications';
import logger from 'js-logger';
import { remakeLastAccruals } from '@shared/api/osi';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';

@injectable()
export class ViewModel {
  isOpenModal = false;

  isLoading = false;

  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);
  }

  remakeAccruals = async () => {
    try {
      if (!this.osiModule.osiId) throw new Error('Не найден osiId');
      this.isLoading = true;
      await remakeLastAccruals(this.osiModule.osiId);
      this.closeModal();
    } catch (e) {
      logger.error(e);
      notifications.error('Ошибка');
    } finally {
      this.isLoading = false;
    }
  };

  openModal = () => {
    this.isOpenModal = true;
  };

  closeModal = () => {
    this.isOpenModal = false;
  };
}
